import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Lock from 'assets/svgs/lock.svg';
import { ONLINE_REGS_STATUSES } from 'shared/constants';
import './StudentDetailsModal.scss';
import { ModalInfo, Spinner, ProgressBar } from 'shared/components';
import { useDispatch } from 'react-redux';
import * as onlineTestingActions from '../duck';

const StudentDetailsModal = ({
  id,
  isOpen,
  handleClose
}) => {
  const { t } = useTranslation();
  const [examineeDetails, setExamineeDetails] = useState({});
  const [loadingData, setLoadingData] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen) {
      (async () => {
        setLoadingData(true);
        const examinee = await dispatch(onlineTestingActions.getOnlineIndividualReg(id, true));
        setExamineeDetails(examinee);
        if (examinee) {
          setLoadingData(false);
        }
      })();
    }
  }, [isOpen]);

  return <ModalInfo
    className="online-examinee-details-modal"
    modalIsOpen={isOpen}
    closeModal={handleClose}
    onSubmit={handleClose}
    headerTitle={t('onlineTesting.examineeDetails.details')}
    saveLabel={t('common.labels.close')}
  >
    {loadingData ? <Spinner hideText noHeight/> :
      <div>
        <h3
          className="examinee-name">{`${examineeDetails.lastName}, ${examineeDetails.firstName}`}</h3>
        <div className="examinee-info-container">
          <div>{t('onlineTesting.examineeDetails.stateStudentId')}</div>
          <div>{examineeDetails.externalStudentId}</div>
          <div>{t('onlineTesting.examineeDetails.textStatus')}</div>
          <div
            className={`examinee-status ${ONLINE_REGS_STATUSES[examineeDetails.testStatus]}`}>{ONLINE_REGS_STATUSES[examineeDetails.testStatus] || ONLINE_REGS_STATUSES.notReady}{examineeDetails.locked &&
          <Lock/>}</div>
          {examineeDetails.markedCompleteReason && <>
            <div>{t('onlineTesting.examineeDetails.reason')}</div>
            <div>{examineeDetails.markedCompleteReason}</div>
          </>}
          <div>{t('onlineTesting.examineeDetails.username')}</div>
          <div>{examineeDetails.loginName}</div>
          <div>{t('onlineTesting.examineeDetails.password')}</div>
          <div>{examineeDetails.loginPass}</div>
        </div>
        {examineeDetails.examState && examineeDetails.examState.length &&
        <>
          <div className="separator"></div>

          <div className="examine-details-progress">
            <h3>{t('onlineTesting.examineeDetails.progress')}</h3>
            {examineeDetails.examState.map((test, idx) =>
              <div className="individual-progress" key={`progress-${idx}`}>
                <div className="progress-name">{test.name}</div>
                <ProgressBar
                  answeredRemaining={t('onlineTesting.examineeDetails.answeredRemaining')}
                  current={test.answeredItems}
                  total={test.totalItems}
                />
              </div>)}
          </div>
        </>}
      </div>}
  </ModalInfo>;

};
export default StudentDetailsModal;
